/*
 * @Descripttion: 底部快速导航
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-08-31 16:31:19
 */
import React from "react"
import { Link } from "react-router-dom";
import styles from './index.module.scss'
import LazyMedia from '@/components/LazyMedia';
interface IProps{
  words: Record<string, string>;
  ctry:string
}
const BottomNav: React.FC<IProps> = ({words, ctry}) => {
  const icon1 = require('../../assets/equity_Info.svg')
  const icon2 = require('../../assets/service_support.svg')
  const icon3 = require('../../assets/about_us.svg')
  const bottomNavList = [
    {
      id: '1',
      title: 'home_footer_nav_title1',
      link: '/support/faq',
      iconImage: icon1
    },
    {
      id: '2',
      title: 'home_footer_nav_title2',
      link: '/support',
      iconImage: icon2
    },
    {
      id: '3',
      title: 'home_footer_nav_title3',
      link: '/about',
      iconImage: icon3
    }
  ]
  return (
    <div className={styles['bto-nav-wrap']}>
      <div className={styles['nav-list']}>
        {
          bottomNavList.map(item => (
            <div className={styles['nav-item']} key={item.id}>
              <LazyMedia type="image" src={item.iconImage} alt="" />
              <h4>{words[item.title]}</h4>
              <Link to={`/${ctry}${item.link}`}>
                <p className={styles['learn-more']}>{words?.common_learn_more}</p>
              </Link>
            </div>
          ))
        }
      </div>
    </div>
  )
}
export default BottomNav
